import { bool, func } from "prop-types";
import React from "react";

import CustomerConsentsItem from "./CustomerConsentsItem";
import Divider from "@components/shared/Divider";
import SimpleButton from "@components/shared/SimpleButton";
import Typography from "@components/shared/Typography";

import { Trans, useTranslation } from "@lib/i18n";

import { CUSTOMER_CONSENTS } from "@shared/constants";

const CustomerConsents = ({ isDisabled, isReadOnly, onModifyClick }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start w-full order-5">
      <Divider className="bg-greyLight my-4" />
      <div className="flex flex-col gap-8 py-8">
        <Typography>
          <Trans
            components={{
              a: <a className="text-primaryOrange underline" target="_blank" />,
            }}
            i18nKey={"myDetails.consents.disclaimer"}
          />
        </Typography>
        {CUSTOMER_CONSENTS.map(consent => (
          <CustomerConsentsItem
            consent={consent}
            isReadOnly={isReadOnly}
            key={consent}
          />
        ))}
      </div>
      {isReadOnly && !isDisabled && (
        <SimpleButton
          className="m-0 mb-4 px-0 pb-2"
          withArrow
          onClick={() => onModifyClick?.()}
        >
          {t("general.modify")}
        </SimpleButton>
      )}
    </div>
  );
};

CustomerConsents.propTypes = {
  isDisabled: bool,
  isReadOnly: bool,
  onModifyClick: func,
};

export default CustomerConsents;
